module.exports = __webpack_public_path__ + "static/media/right-arrow.18ccdbf5.svg";